import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Utility } from '../_service/utility';

@Injectable()
export class SeoService {

  constructor(
    private _titleService: Title,
    private meta: Meta,
    private _utility: Utility,
    @Inject(DOCUMENT) private document: Document) {
  }


  private seperator = "-";
  public otherWise = this._utility.getSiteConfig.title + '是分发,上传,社区一体的在线视频平台,可免费在线观看最新电影,电视剧,综艺,动漫,在线视频';
  public slogon = "海量高清视频免费在线观看";
  public keywords = "电影,电视剧,综艺,动漫,视频,视频分享,视频搜索,视频播放,视频社区,海外视频,海外影院,在线视频,免费视频,免费电影,高清,免费在线观看";
  setTitle(...title: string[]) {

    var mytitle = '';
    var result = "";
    if (title != null && title.length > 0) {
      for (var i = 0; i < title.length; ++i) {
        if (!!title[i])
          result = title[i] + (result ? this.seperator + result : "");
      }
    }
    if (result.indexOf("{SiteName}") > -1) {
      mytitle = result.replace("{SiteName}", this._utility.getSiteConfig.title);
    }
    else {
      result = result ? (result + this.seperator + this._utility.getSiteConfig.title) : this._utility.getSiteConfig.title;
      mytitle = result == this._utility.getSiteConfig.title ? result + (this.slogon ? this.seperator + this.slogon : "") : result;
    }
    this._titleService.setTitle(mytitle);
    this.meta.updateTag({ name: 'title', content: mytitle });
    this.meta.updateTag({ property: 'og:title', content: mytitle });
    this.setOGUrl(this.document.URL);

  }

  setDescription(...desc: string[]) {
    var description = !!desc && desc.length > 0 ? desc.filter(p => p != null && p != '').join(" | ") : this.otherWise;
    description = description.replace("{SiteName}", this._utility.getSiteConfig.title);
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ property: 'og:description', content: description });
  }

  setKeywords(...key: string[]) {
    var keywords = !!key && key.length > 0 ? key.filter(p => p != null && p != '').join(" | ") : this.keywords;
    this.meta.updateTag({ name: 'keywords', content: keywords });
    this.meta.updateTag({ property: 'og:keywords', content: keywords });
  }

  setImage(url) {
    let tag = this.meta.getTag(`property="og:image"`);
    if (tag == null) {
      this.meta.addTag({ property: 'og:image', content: url });
    }
    else {
      this.meta.updateTag({ property: 'og:image', content: url });
    }
  }

  removeImage() {
    this.meta.removeTag(`property="og:image"`);
  }
  setOGUrl(...url: string[]) {
    var ogurl = !!url && url.length > 0 ? url.filter(p => p != null && p != '').join(" | ") : 'https://www.' + this._utility.GetHost();
    this.meta.updateTag({ property: 'og:url', content: ogurl });
    this.setLinkRel(ogurl);

  }
  private setLinkRel(link) {
    let element = this.document.head.querySelectorAll('link[rel="alternate"]');
    let mobileLinke = link.replace("www.", "m.");
    let element1 = this.document.head.querySelector('link[rel="canonical"]');
    element?.forEach(p => p.setAttribute("href", mobileLinke))
    element1?.setAttribute("href", link);
  }
}
